<template>

    <!-- BRANDING -->
    <div class="branding" :class="[imageOrientationClass, addClass]">

        <transition
            name="fade"
            mode="out-in"
            appear>

            <a :href="pageHref" @click="trackEvent" :title="altText">
                <img :srcset="getImgSrcSet(logo)" :src="logo.x1.url" :alt="altText" v-images-loaded:on.progress="imageProgress" />
            </a>

        </transition>

    </div>
    <!-- END BRANDING -->

</template>


<script>

    import imagesLoaded from 'vue-images-loaded';

    let vm = {};

    export default {

        name: 'branding',

        props: [
            'logo',
            'altText',
            'link',
            'linkTarget',
            'addClass'
        ],

        directives: {
            imagesLoaded
        },

        components: {},

        data() {
            return {
                imageSrc: this.logo.x1.url,
                imageSrcSet: this.logo.x1.url + ' 1x,' + this.logo.x2.url + ' 2x,' + this.logo.x3.url + ' 3x',
                imageSize: null,
                imageThreshold: 1.5,
                imageOrientationClass: 'horizontal'
            }
        },

        computed: {

            target() {
                return (this.linkTarget) ? this.linkTarget : '_blank';
            },

            pageHref() {
                return '/' + window.location.search;
            }

        },

        created() {
            //console.info('%cBranding::created', 'color:dodgerblue;');
        },

        mounted() {
            //console.info('%cBranding::mounted', 'color:green;');

            vm = this;

        },

        methods: {

            imageProgress(ins, img) {
                const result = img.isLoaded ? 'loaded' : 'broken';

                vm.imageSize = {
                    width: img.img.width,
                    height: img.img.height
                };

                let _ratio = vm.imageSize.width / vm.imageSize.height;

                if (_ratio < vm.imageThreshold) {
                    vm.imageOrientationClass = 'vertical';
                }

                vm.$eventBus.$emit('footer:image', vm.imageOrientationClass);

                setTimeout(function() {
                    vm.$eventBus.$emit('branding:loaded');
                }, 2000)

            },

            getImgSrcSet(logo) {
                return logo.x1.url + ' 1x,' + logo.x2.url + ' 2x,' + logo.x3.url + ' 3x';
            },

            trackEvent() {
                gtag('event', 'Company Logo Image', {
                    'event_category': 'MBRe: Residential',
                    'event_label': ''
                });
            }

        }

    }


</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .branding {
        background-color: $white-100;
        line-height: 0;
        padding: 5px 5px;
        flex: 0 0 auto;

        &.horizontal {
            max-width: 300px;
            align-self: center;

            & img {
                max-width: 100%;
                height: auto;
                max-height: 85px;
            }
        }

        &.vertical {
            align-self: center;

            & img {
                max-width: 100%;
                height: auto;
                max-height: 140px;
            }
        }

        &.mobile {

            & img {
                max-height: 112px;
            }
        }
    }

    a {
        display: block;
    }

</style>


// WEBPACK FOOTER //
// Branding.vue?23eac53c